// Tab "Nghi ngờ": 1 máy nhiều tài khoản, 1 tài khoản nhiều máy (7 ngày). Bấm userId → mở hồ sơ ở tab Người tham gia.
import { useCallback, useEffect, useState } from "react";
import { Alert, Button, Select, Space, Spin, Table, message } from "antd";
import xuProgramApi from "../../../api/xuProgramApi";
import { apiError } from "./xu-format-helpers";

export default function XuSuspiciousTab({ onOpenUser }) {
    const [days, setDays] = useState(7);
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);

    const load = useCallback(async () => {
        setLoading(true);
        try {
            const res = await xuProgramApi.getSuspicious(days);
            setData(res.data.data);
        } catch (e) {
            message.error(apiError(e, "Không tải được danh sách nghi ngờ"));
        } finally {
            setLoading(false);
        }
    }, [days]);
    useEffect(() => {
        load();
    }, [load]);

    const userLink = (u) => (
        <Button key={u.userId} type="link" size="small" onClick={() => onOpenUser(u.userId)}>{u.name || "(chưa đặt tên)"} #{u.userId}</Button>
    );

    return (
        <Space direction="vertical" size="middle" className="w-full">
            <Alert type="info" showIcon message="Đây chỉ là dấu hiệu để admin xem xét, chưa phải bằng chứng gian lận (mã máy do app tự tạo, người dùng đổi điện thoại cũng làm tăng số máy)." />
            <Space>
                <span>Xét trong</span>
                <Select value={days} onChange={setDays} style={{ width: 120 }} options={[3, 7, 14, 30].map((n) => ({ value: n, label: `${n} ngày` }))} />
                <Button onClick={load} loading={loading}>Làm mới</Button>
            </Space>
            {!data ? <Spin className="block mx-auto mt-10" /> : (
                <>
                    <Table
                        title={() => <b>Một máy, nhiều tài khoản</b>}
                        size="small"
                        rowKey="installId"
                        loading={loading}
                        dataSource={data.sharedInstalls}
                        locale={{ emptyText: "Không có máy nào bị nhiều tài khoản dùng chung" }}
                        columns={[
                            { title: "Mã máy", dataIndex: "installId", render: (v) => <code>{v}</code> },
                            { title: "Số tài khoản", dataIndex: "userCount", align: "right", width: 120 },
                            { title: "Các tài khoản", render: (_, r) => r.users.map(userLink) },
                        ]}
                    />
                    <Table
                        title={() => <b>Một tài khoản, nhiều máy (hơn 3 máy)</b>}
                        size="small"
                        rowKey="userId"
                        loading={loading}
                        dataSource={data.manyInstalls}
                        locale={{ emptyText: "Không có tài khoản nào dùng quá 3 máy" }}
                        columns={[
                            { title: "Tài khoản", render: (_, r) => userLink(r) },
                            { title: "Số máy", dataIndex: "installCount", align: "right", width: 120 },
                        ]}
                    />
                </>
            )}
        </Space>
    );
}
